import { render, staticRenderFns } from "./OrganizationMultiSelect.vue?vue&type=template&id=b32704ea&scoped=true&"
import script from "./OrganizationMultiSelect.vue?vue&type=script&lang=js&"
export * from "./OrganizationMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32704ea",
  null
  
)

export default component.exports